import { createRoot } from "solid-js"
import { StateT as GeneratedStateT, StateType as GeneratedStateType } from "../../../../engine/bindings/typescript/tbs"
import { Group, type Object3D } from "three"
import createEngineForUI from "../../../core/engine/createEngineForUI"
import { toGeneratedEntity } from "../../../core/engine/engineWasmCodec"
import { createPlainEntity } from "../../../core/entity/EntityType/Plain"
import { createSeaEntity } from "../../../core/entity/EntityType/Sea"
import { createShoalEntity } from "../../../core/entity/EntityType/Shoal"

export default function makeShoalForIconObject3D(
  callback: (newGroup: Object3D) => void
): void {
  createRoot((disposeRoot) => {
    const engine = createEngineForUI()
    let id = 1
    const ent1 = createSeaEntity(id++, 0, 0)
    const ent2 = createSeaEntity(id++, 0, 1)
    const ent3 = createSeaEntity(id++, 0, 2)
    const ent4 = createSeaEntity(id++, 1, 0)
    const ent5 = createShoalEntity(id++, 1, 1)
    const ent6 = createPlainEntity(id++, 1, 2)
    const ent7 = createPlainEntity(id++, 2, 0)
    const ent8 = createPlainEntity(id++, 2, 1)
    const ent9 = createPlainEntity(id++, 2, 2)
    void engine.bootstrapWasmState(new GeneratedStateT(
      1,
      null,
      null,
      null,
      GeneratedStateType.Map,
      3,
      3,
      [
        ent1,
        ent2,
        ent3,
        ent4,
        ent5,
        ent6,
        ent7,
        ent8,
        ent9,
      ].map(toGeneratedEntity)
    ))
    // const mesh1 = createShoalTerrainMesh(engine, [
    //   ent5,
    // ])
    // callback(mesh1)

    // TODO fix icons?

    callback(new Group)

    disposeRoot()
  })
}
